import './resourceActions.scss'

/**
 * Generates action buttons for a resource
 *
 * @example
 * <tmr-resource-actions actions="['edit', 'delete']" resource="::item"></tmr-resource-actions>
 *
 * @namespace
 * @alias tmrResourceActions
 * @type {ngDirective}
 */
function tmrResourceActionsDirective($compile) {
  'ngInject'
  return {
    bindToController: {
      actions: '<',
      resource: '<',
    },
    controller: () => {},
    controllerAs: '$ctrl',
    link,
    restrict: 'E',
    scope: {},
  }

  function link(scope, element) {
    let html = scope.$ctrl.actions
      .map(
        action =>
          `<tmr-resource-action-${action} resource="::$ctrl.resource"></tmr-resource-action-${action}>`
      )
      .join('')
    let e = angular.element(html)
    element.append(e)
    $compile(e)(scope)
  }
}

export const directive = ['tmrResourceActions', tmrResourceActionsDirective]
